import * as React from 'react';
import TextField from '@mui/material/TextField';

export default function TimePickerWidget(props) {
    const { number } = props;
    const [value, setValue] = React.useState(0);

    React.useEffect(() => {
        setValue(number);
    }, [number])

    const handleChange = (n) => {
        if (parseInt(n) > props.max) {
            n = props.max;
        }
        if (parseInt(n) < props.min) {
            n = props.min;
        }
        setValue(n);
        props.handleChange(n);
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <TextField
                type="number"
                className="time-input"
                InputProps={{
                    inputProps: {
                        max: props.max, min: props.min
                    }
                }}
                value={value}
                onChange={(e) => {
                    const _value = parseInt(e.target.value);
                    if (!_value || (_value >= props.min && _value <= props.max)) {
                        setValue(_value);
                        handleChange(_value);
                    }
                }}
                size={'small'}
                style={{ width: '50px' }}
            />
        </div>
    )
}
